import { Sidebar } from 'primereact/sidebar';
import { Button } from 'primereact/button';
import React, { useState } from 'react';
import './MobileMenu.scss';
import { Link, NavLink } from 'react-router-dom';
import { PRICING, PROJECTS, QUESTIONS, SETTINGS } from '../../../routes/path';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../../contexts/auth/AuthContext';
import { useAccount } from '../../../contexts/account/AccountContexts';
import useBilling from '../../../hooks/account/UseBilling';
import useDisabledAccount from '../../../hooks/account/UseDisabledAccount';
import { PRIVACY_POLICY } from '../../../utils/urls';
import AdvisorBox from '../advisor-box/AdvisorBox';

const MobileMenu = () => {
  const { logout } = useAuth();
  const { t } = useTranslation();
  const [visible, setVisible] = useState(false);
  const canShowBilling = useBilling();
  const { isDisabled } = useDisabledAccount();
  const { accountResponse } = useAccount();

  return (
    <>
      <Sidebar
        visible={visible}
        onHide={() => setVisible(false)}
        position="right"
        className="mobile-sidebar"
      >
        <div className="sidebar-header">
          <Button className="close-button" onClick={() => setVisible(false)}>
            <span className="close-icon"></span>
          </Button>
        </div>

        <div className="menu-list">
          {!isDisabled && (
            <>
              <NavLink
                to={PROJECTS}
                className={({ isActive }) => (isActive ? 'menu__item--active' : '') + ' menu__item'}
                onClick={() => setVisible(false)}
              >
                <i className="ico--bookmark ico--sm" />
                <span className="menu__text">{t('allProjects')}</span>
              </NavLink>

              <NavLink
                to={QUESTIONS}
                className={({ isActive }) => (isActive ? 'menu__item--active' : '') + ' menu__item'}
                onClick={() => setVisible(false)}
              >
                <i className="ico--clipboard ico--sm" />
                <span className="menu__text">{t('promptsQuestions')}</span>
              </NavLink>
            </>
          )}
          {canShowBilling && (
            <>
              <NavLink
                to={PRICING}
                className={({ isActive }) => (isActive ? 'menu__item--active' : '') + ' menu__item'}
                onClick={() => setVisible(false)}
              >
                <i className="ico--card ico--sm" />
                <span className="menu__text">{t('subscription')}</span>
              </NavLink>
            </>
          )}
          <NavLink
            to="/faq"
            className={({ isActive }) => (isActive ? 'menu__item--active' : '') + ' menu__item'}
            onClick={() => setVisible(false)}
          >
            <i className="ico--chat ico--sm" />
            <span className="menu__text">{t('faq')}</span>
          </NavLink>

          <NavLink to="https://chatbeat.com/llm-seo" target="_blank" className="menu__item">
            <i className="ico--chart ico--sm" />
            <span className="menu__text">{t('improveAIRanking')}</span>
          </NavLink>

          <NavLink
            to={SETTINGS}
            className={({ isActive }) => (isActive ? 'menu__item--active' : '') + ' menu__item'}
            onClick={() => setVisible(false)}
          >
            <i className="ico--settings ico--sm" />
            <span className="menu__text">{t('settings')}</span>
          </NavLink>

          <button className="menu__item" onClick={logout}>
            <i className="ico--logout ico--sm" />
            <span className="menu__text">{t('logout')}</span>
          </button>

          <div className="mobile-advisor-box">
            <AdvisorBox />
          </div>
        </div>
        <ul className="privacy-policy">
          <li>
            <Link to={PRIVACY_POLICY} target="_blank">
              {t('privacyPolicy')}
            </Link>
          </li>
          <li>
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                (window as any).OneTrust?.ToggleInfoDisplay();
              }}
            >
              {t('customizeCookie')}
            </a>
          </li>
        </ul>
      </Sidebar>

      <div className="hamburger-container">
        <NavLink to={PROJECTS} className="logo">
          <div className="logo-box" />
        </NavLink>
        <Button
          icon="pi pi-bars"
          className="hamburger-button"
          onClick={() => setVisible(true)}
          aria-label="Open menu"
        />
      </div>
    </>
  );
};

export default MobileMenu;
